import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
    marginBottom: '30px',
  },
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
  footer: {
    '& > button': {
      marginLeft: '6px',
    },
  },

  content: {
    '& section > div:first-of-type': {
      width: 581,
      marginLeft: 0,
      marginRight: 0,
    },

    '& section > p:first-of-type': {
      fontSize: fonts.sizes.xsmall,
      fontWeight: fonts.weights.normal,
      marginTop: spacing.xsmall,
      marginLeft: spacing.xsmall,
      letterSpacing: '0.4px',
      color: colors.gray,
    },

    '& aside > div > div:first-of-type': {
      alignItems: 'center',
    },

    '& h4': {
      fontSize: fonts.sizes.small,
      fontWeight: fonts.weights.normal,
      color: colors.uploadedItemLegend,
      lineHeight: '20px',
    },
  },
});

export default useStyles;
